<template>
    <div class="register register-wrapper" v-bind:class="{ 'mt-0 pb-0': !$isMobile }">
        <div class="content">
            <div class="modal-header">
                <button data-bs-toggle="modal" data-bs-target="#loginModal" type="button" class="btn-close btn-close-red-500" aria-label="Close"></button>
            </div>
            <div class="text-red subtitle mb-3 text-center" v-if="!$isMobile">Logga in på Familjekortet!</div>
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="register-base">
                        <img src="/assets/frontend/register_base.svg" alt="" />

                        <div class="register-inputs login-inputs pb-4">
                            <form @submit.prevent="login" @keydown="form.errors[$event.target.name] = null">

                                <input type="text" class="form-control" placeholder="* E-post" name="email" v-model="form.email" />
                                <div v-if="form.errors.email" class="invalid-feedback d-block text-left">
                                    {{ form.errors.email }}
                                </div>

                                <input type="password" class="form-control" placeholder="* Lösenord" name="password" v-model="form.password" />
                                <div v-if="form.errors.password" class="invalid-feedback d-block text-left">
                                    {{ form.errors.password }}
                                </div>

                                <button type="button" class="btn login-btn" v-if="form.processing">Loggar in...</button>
                                <button type="submit" class="btn login-btn" v-else>Logga in</button>
                            </form>
                            <div class="mt-2 flex">
                                <label class="text-yellow">
                                    <input type="checkbox" v-model="form.remember" :value="true" />
                                    Kom ihåg mig
                                </label>
                                <span class="ml-auto" data-bs-toggle="modal" data-bs-target="#forgotPasswordModal">Glömt lösenord?</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="buttons" v-bind:class="{ 'buttons-mobile': $isMobile }">
                        <span class="d-block question mt-4">
                            Har du inget Familjekort? No worries, det är gratis och tar en minut att registrera sig.
                        </span>

                        <button class="btn btn-danger w-100 font-weight-bold" data-bs-toggle="modal" data-bs-target="#registerModal">Bli medlem</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$isMobile'],
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                    password: null,
                    remember: false,
                }),
            }
        },
        methods: {
            login(){
                if (this.form.processing) {
                    return;
                }

                this.form.processing = true;

                setTimeout(() => {
                    this.form.post(`/api/member/login`, {
                        onSuccess: () => {
                            this.form.email = null;
                            this.form.password = null;
                            this.form.errors.email = null;
                            $('#loginModal').modal('hide');
                        }
                    });
                }, 300);
            }
        }
    }
</script>
